/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ExternalLinkNew from './external-link-new.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ExternalLinkNew {...validProps} />;
}

SvgComponent.iconName = 'externalLinkNew';

export const ExternalLinkNewIcon = svgIconWrapper(SvgComponent);
